import React, { useState, useEffect, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import instance from './axios-instance';
import Systems from './SystemFunction';

const CSS = `
.affroot{--bg:#360000;--bg2:#470404;--card:#531010;--line:#7a2222;--gold:#ffcf47;--gold2:#ffe08a;--text:#f6e9e9;--muted:#d9a8a8;--red:#bc0009;--red2:#e01522;background:var(--bg);color:var(--text);min-height:100vh;font-family:'Segoe UI',Tahoma,'Noto Sans Thai',sans-serif}
.affroot *{box-sizing:border-box}
.aff-wrap{max-width:1200px;margin:0 auto;padding:0 20px}
.aff-btn{border:none;cursor:pointer;border-radius:10px;padding:11px 22px;font-weight:700;font-size:15px}
.aff-gold{background:linear-gradient(135deg,var(--red2),var(--red));color:#fff;box-shadow:0 6px 18px rgba(188,0,9,.35)}
.aff-ghost{background:transparent;border:1px solid var(--line);color:var(--text)}
.aff-input{width:100%;background:#2b0202;border:1px solid var(--line);color:var(--text);border-radius:9px;padding:11px 12px;font-size:14px;outline:none}
.aff-input:focus{border-color:var(--gold)}
.aff-input:-webkit-autofill,.aff-input:-webkit-autofill:hover,.aff-input:-webkit-autofill:focus,.aff-input:-webkit-autofill:active{-webkit-text-fill-color:var(--text)!important;-webkit-box-shadow:0 0 0 1000px #2b0202 inset!important;caret-color:var(--text);transition:background-color 9999s ease-out 0s}
.aff-input::placeholder{color:#c58f8f}
.affroot select.aff-input{color:var(--text);background:#2b0202}
.affroot select.aff-input option{color:#111;background:#fff}
.aff-header{position:sticky;top:0;z-index:50;background:linear-gradient(180deg,#a80000,#8a0000);border-bottom:1px solid #5a0000}
.aff-nav{display:flex;align-items:center;gap:12px;height:62px;flex-wrap:nowrap}
.aff-menu{display:flex;gap:14px;margin-left:8px;flex:1;min-width:0;white-space:nowrap}
.aff-menu a{color:#ffd9d9;font-size:16px;font-weight:700;cursor:pointer}
.aff-menu a:hover{color:var(--gold)}
.aff-loginmini{display:flex;gap:6px;align-items:center;flex-shrink:0}
.aff-loginmini .aff-input{width:170px;padding:12px 14px;font-size:17px;height:44px}
.aff-loginmini .aff-btn{padding:12px 22px;font-size:17px;height:44px}
@media(max-width:1080px){.aff-menu{display:none}}
@media(max-width:620px){.aff-loginmini .aff-input,.aff-loginmini .aff-inw{display:none}}
#aff-loginsec .aff-input,.aff-logincard .aff-input{padding:14px 15px;font-size:17px;height:50px}
.aff-logincard .aff-field label{font-size:15px;margin-bottom:6px;display:block}
.aff-inw{position:relative;display:block}
.aff-inw .aff-input,#aff-loginsec .aff-inw .aff-input,.aff-logincard .aff-inw .aff-input{padding-left:44px;width:100%}
.aff-loginmini .aff-inw .aff-input{width:170px}
.aff-inw::before{content:"";position:absolute;left:14px;top:0;bottom:0;margin:auto;width:20px;height:20px;background-repeat:no-repeat;background-size:20px 20px;pointer-events:none;z-index:5}
.aff-inw.-user::before{background-image:url("data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%20fill='none'%20stroke='%23ffd54a'%20stroke-width='2.2'%3E%3Ccircle%20cx='12'%20cy='8'%20r='4'/%3E%3Cpath%20d='M4%2020c0-4%204-6%208-6s8%202%208%206'/%3E%3C/svg%3E")}
.aff-inw.-lock::before{background-image:url("data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%20fill='none'%20stroke='%23ffd54a'%20stroke-width='2.2'%3E%3Crect%20x='4'%20y='10'%20width='16'%20height='11'%20rx='2'/%3E%3Cpath%20d='M8%2010V7a4%204%200%200%201%208%200v3'/%3E%3C/svg%3E")}
.aff-hero{background:linear-gradient(180deg,#520606,var(--bg))}
.aff-cta{text-align:center;padding:22px 20px 8px}
.aff-stats{display:flex;gap:26px;justify-content:center;margin-top:22px;flex-wrap:wrap}
.aff-stats div b{display:block;font-size:26px;color:var(--gold)}
.aff-stats div small{color:var(--muted)}
.aff-sec{padding:56px 0}
.aff-sectitle{text-align:center;margin-bottom:36px}
.aff-sectitle h2{font-size:28px;font-weight:800}
.aff-sectitle p{color:var(--muted);margin-top:8px}
.aff-grid3{display:grid;grid-template-columns:repeat(3,1fr);gap:18px}
@media(max-width:900px){.aff-grid3{grid-template-columns:1fr}}
.aff-card{background:var(--card);border:1px solid var(--line);border-radius:16px;padding:22px}
.aff-card .ico{width:46px;height:46px;border-radius:12px;display:grid;place-items:center;background:rgba(224,21,34,.18);color:var(--gold);font-size:20px;margin-bottom:12px}
.aff-card h3{font-size:17px;margin:0 0 6px}.aff-card p{color:var(--muted);font-size:14px;margin:0}
.aff-comm{overflow:hidden;border:1px solid var(--line);border-radius:16px}
.aff-tb{width:100%;border-collapse:collapse}
.aff-tb th,.aff-tb td{padding:13px 14px;text-align:center;border-bottom:1px solid var(--line)}
.aff-tb thead th{background:#2b0202;color:var(--gold)}
.aff-tb td b{color:var(--gold)}
.aff-footer{border-top:1px solid var(--line);padding:26px 0;color:var(--muted);text-align:center;font-size:13px}
.aff-overlay{position:fixed;inset:0;background:rgba(4,7,12,.72);display:flex;align-items:flex-start;justify-content:center;overflow:auto;padding:40px 16px;z-index:100}
.aff-modal{background:var(--bg2);border:1px solid var(--line);border-radius:16px;width:100%;max-width:560px}
.aff-modal-h{display:flex;justify-content:space-between;align-items:center;padding:16px 20px;border-bottom:1px solid var(--line)}
.aff-modal-h .x{cursor:pointer;color:var(--muted);font-size:22px}
.aff-modal-b{padding:20px}
.aff-row2{display:grid;grid-template-columns:1fr 1fr;gap:12px}
@media(max-width:560px){.aff-row2{grid-template-columns:1fr}}
.aff-field{margin-bottom:12px}
.aff-field label{font-size:13px;color:var(--muted);display:block;margin:0 0 5px}
.aff-sub{font-weight:800;color:var(--gold);margin:6px 0 12px;font-size:15px}
.aff-msg{padding:10px 12px;border-radius:9px;font-size:14px;margin-bottom:12px}
.aff-msg.ok{background:rgba(34,197,94,.12);color:#86efac}.aff-msg.err{background:rgba(239,68,68,.12);color:#fca5a5}
.aff-layout{max-width:1180px;margin:20px auto;display:grid;grid-template-columns:220px 1fr;gap:18px;padding:0 18px}
@media(max-width:820px){.aff-layout{grid-template-columns:1fr}}
.aff-side{background:var(--bg2);border:1px solid var(--line);border-radius:14px;padding:10px;height:fit-content}
.aff-side a{display:block;padding:12px 14px;border-radius:9px;color:var(--muted);font-weight:600;cursor:pointer}
.aff-side a.active,.aff-side a:hover{background:rgba(224,21,34,.18);color:#fff}
.aff-cards{display:grid;grid-template-columns:repeat(4,1fr);gap:14px}
@media(max-width:900px){.aff-cards{grid-template-columns:repeat(2,1fr)}}
.aff-stat{background:var(--card);border:1px solid var(--line);border-radius:14px;padding:18px}
.aff-stat .lb{color:var(--muted);font-size:13px}.aff-stat .vl{font-size:24px;font-weight:900;margin-top:4px}
.aff-stat .vl.gold{color:var(--gold)}.aff-stat .vl.green{color:#4ade80}
.aff-badge{padding:3px 9px;border-radius:20px;font-size:12px;font-weight:700}
.aff-badge.on{background:rgba(34,197,94,.18);color:#4ade80}.aff-badge.off{background:rgba(217,168,168,.12);color:var(--muted)}
`;

const API = { SYSTEM: Systems, LOGINURL: 'https://aff.newworld.center/Login' };
const fmt = (n) => Number(n || 0).toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const COMM_TIERS = [
  {
    key: 'start', name: 'เริ่มต้น', range: 'ไม่จำกัด', rate: 'สูงสุด 25%', color: '#cd7f32',
    tiers: [['0 - 99,999', '20%'], ['100,000 ขึ้นไป', '25%']],
    benefits: ['เริ่มรับค่าคอมได้ทันทีหลังสมัคร', 'จ่ายค่าคอมรายสัปดาห์', 'ไม่มีขั้นต่ำสมาชิก'],
  },
  {
    key: 'silver', name: 'เงิน', range: 'ตั้งแต่ 100,000', rate: 'สูงสุด 35%', color: '#c0c0c0',
    tiers: [['100,000 - 299,999', '30%'], ['300,000 ขึ้นไป', '35%']],
    benefits: ['ค่าคอมสูงขึ้นทุกระดับ', 'มีทีมซัพพอร์ตพันธมิตรเฉพาะ', 'โบนัสพิเศษรายเดือน'],
  },
  {
    key: 'gold', name: 'ทอง', range: 'ตั้งแต่ 500,000', rate: 'สูงสุด 45%', color: '#f7c948',
    tiers: [['500,000 - 999,999', '40%'], ['1,000,000 ขึ้นไป', '45%']],
    benefits: ['ค่าคอมระดับสูง', 'ผู้จัดการบัญชีส่วนตัว', 'โปรโมชั่นเฉพาะพันธมิตรระดับทอง'],
  },
  {
    key: 'platinum', name: 'แพลทินัม', range: 'ตั้งแต่ 1,000,000', rate: 'สูงสุด 50%', color: '#7fd7ff',
    tiers: [['1,000,000 - 4,999,999', '48%'], ['5,000,000 ขึ้นไป', '50%']],
    benefits: ['ค่าคอมสูงสุดของระบบ', 'เงื่อนไขถอนพิเศษ', 'ดูแลระดับ VIP + ของรางวัลพิเศษ'],
  },
];
function decodeUser(tk) {
  try { const p = JSON.parse(atob(tk.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))); return (p.message && p.message.username) || p.username || p.name || ''; } catch (e) { return ''; }
}

export default function AffiliatePortal() {
  const location = useLocation();
  const navigate = useNavigate();
  const isDash = location.pathname.indexOf('/affiliate/dashboard') === 0;
  const isLogin = location.pathname.indexOf('/affiliate/login') === 0;

  const [token, setToken] = useState(() => localStorage.getItem('aff_token') || '');
  const [showReg, setShowReg] = useState(false);
  const [regMsg, setRegMsg] = useState(null);
  const [regLoading, setRegLoading] = useState(false);
  const [lg, setLg] = useState({ u: '', p: '' });
  const [loginErr, setLoginErr] = useState('');
  const [commDetail, setCommDetail] = useState(null);
  const [reg, setReg] = useState({ name: '', user: '', pass: '', pass2: '', phone: '', email: '', line: '', tg: '', teams: '', time: '', secq: '', seca: '', ref: '', agree: false, bankid: '', accountno: '', accountname: '', wnet: 'TRC20', waddr: '' });
  const [regBanks, setRegBanks] = useState([]);

  // dashboard state
  const [dpage, setDpage] = useState('overview');
  const [dash, setDash] = useState(null);
  const [netPage, setNetPage] = useState(1);
  const [rp, setRp] = useState({ from: '', to: '' });
  // wallet / withdraw / promotion state
  const [wallet, setWallet] = useState(null);
  const [wform, setWform] = useState({ bankid: '', accountno: '', accountname: '', walletaddress: '', walletnetwork: 'TRC20' });
  const [wdAmount, setWdAmount] = useState('');
  const [wdMethod, setWdMethod] = useState('bank');
  const [wdList, setWdList] = useState([]);
  const [promos, setPromos] = useState([]);
  const [walletMsg, setWalletMsg] = useState(null);
  const [reflink, setReflink] = useState(null);
  const [copied, setCopied] = useState(false);
  const [byproduct, setByproduct] = useState(null);
  const [subaff, setSubaff] = useState([]);
  const [pwd, setPwd] = useState({ old: '', n1: '', n2: '' });
  const [pwdMsg, setPwdMsg] = useState(null);
  const [summary, setSummary] = useState(null);

  const setR = (k, v) => setReg((s) => ({ ...s, [k]: v }));

  useEffect(() => {
    if (!showReg) return;
    (async () => {
      try { const res = await instance.post('/api/v1/affbanks', { System: API.SYSTEM }); if (res.data && res.data.status === 200) setRegBanks(res.data.message.banks || []); } catch (e) { /* noop */ }
    })();
  }, [showReg]);

  const loadDash = useCallback(async () => {
    const tk = localStorage.getItem('aff_token'); if (!tk) return;
    const uname = decodeUser(tk); if (!uname) return;
    try {
      const res = await instance.post('/api/v1/affdashboard', { System: API.SYSTEM, affusername: uname, page: netPage, perPage: 10, dateFrom: rp.from || null, dateTo: rp.to || null });
      if (res.data && res.data.status === 200) setDash(res.data.message);
      else if (res.data && res.data.status === 201) { localStorage.removeItem('aff_token'); setToken(''); navigate('/affiliate'); }
    } catch (e) { /* noop */ }
  }, [netPage, rp.from, rp.to, navigate]);

  const loadWallet = useCallback(async () => {
    const u = decodeUser(localStorage.getItem('aff_token') || ''); if (!u) return;
    try {
      const res = await instance.post('/api/v1/affwallet', { System: API.SYSTEM, affusername: u });
      if (res.data && res.data.status === 200) {
        const m = res.data.message; setWallet(m);
        setWform({ bankid: m.profile.bankid || '', accountno: m.profile.accountno || '', accountname: m.profile.accountname || '', walletaddress: m.profile.walletaddress || '', walletnetwork: m.profile.walletnetwork || 'TRC20' });
      }
    } catch (e) { /* noop */ }
  }, []);
  const loadWdHistory = useCallback(async (p) => {
    const u = decodeUser(localStorage.getItem('aff_token') || ''); if (!u) return;
    try { const res = await instance.post('/api/v1/affwithdrawhistory', { System: API.SYSTEM, affusername: u, page: p || 1, perPage: 20 }); if (res.data && res.data.status === 200) setWdList(res.data.message.list || []); } catch (e) { /* noop */ }
  }, []);
  const loadPromos = useCallback(async () => {
    try { const res = await instance.post('/api/v1/affpromotions', { System: API.SYSTEM }); if (res.data && res.data.status === 200) setPromos(res.data.message.promotions || []); } catch (e) { /* noop */ }
  }, []);
  const loadReflink = useCallback(async () => {
    const u = decodeUser(localStorage.getItem('aff_token') || ''); if (!u) return;
    try { const res = await instance.post('/api/v1/affreflink', { System: API.SYSTEM, affusername: u, origin: window.location.origin }); if (res.data && res.data.status === 200) setReflink(res.data.message); } catch (e) { /* noop */ }
  }, []);
  const loadByProduct = useCallback(async () => {
    const u = decodeUser(localStorage.getItem('aff_token') || ''); if (!u) return;
    try { const res = await instance.post('/api/v1/affreportbyproduct', { System: API.SYSTEM, affusername: u }); if (res.data && res.data.status === 200) setByproduct(res.data.message); } catch (e) { /* noop */ }
  }, []);
  const loadSubaff = useCallback(async () => {
    const u = decodeUser(localStorage.getItem('aff_token') || ''); if (!u) return;
    try { const res = await instance.post('/api/v1/affsubaffiliates', { System: API.SYSTEM, affusername: u }); if (res.data && res.data.status === 200) setSubaff(res.data.message.list || []); } catch (e) { /* noop */ }
  }, []);
  const loadSummary = useCallback(async () => {
    const u = decodeUser(localStorage.getItem('aff_token') || ''); if (!u) return;
    try { const res = await instance.post('/api/v1/affportalsummary', { System: API.SYSTEM, affusername: u }); if (res.data && res.data.status === 200) setSummary(res.data.message); } catch (e) { /* noop */ }
  }, []);
  const copyLink = () => { try { navigator.clipboard.writeText(reflink && reflink.link ? reflink.link : ''); setCopied(true); setTimeout(() => setCopied(false), 1500); } catch (e) { /* noop */ } };
  const changePwd = async () => {
    const u = decodeUser(localStorage.getItem('aff_token') || ''); if (!u) return;
    if ((pwd.n1 || '').length < 4) { toast.error('รหัสผ่านใหม่อย่างน้อย 4 ตัว'); return; }
    if (pwd.n1 !== pwd.n2) { toast.error('รหัสผ่านใหม่ไม่ตรงกัน'); return; }
    try {
      const res = await instance.post('/api/v1/affchangepassword', { System: API.SYSTEM, affusername: u, oldpassword: pwd.old, newpassword: pwd.n1 });
      const ok = res.data && res.data.status === 200;
      if (ok) { toast.success((res.data && res.data.message) || 'เปลี่ยนรหัสผ่านเรียบร้อย'); setPwd({ old: '', n1: '', n2: '' }); }
      else toast.error((res.data && res.data.message) || 'ไม่สำเร็จ');
    } catch (e) { toast.error('เชื่อมต่อไม่สำเร็จ'); }
  };

  const saveBank = async () => {
    const u = decodeUser(localStorage.getItem('aff_token') || ''); if (!u) return;
    try {
      const res = await instance.post('/api/v1/affwalletsave', { System: API.SYSTEM, affusername: u, ...wform });
      const ok = res.data && res.data.status === 200;
      if (ok) { toast.success((res.data && res.data.message) || 'บันทึกข้อมูลบัญชีเรียบร้อย'); loadWallet(); }
      else toast.error((res.data && res.data.message) || 'บันทึกไม่สำเร็จ');
    } catch (e) { toast.error('เชื่อมต่อไม่สำเร็จ'); }
  };
  const submitWithdraw = async () => {
    const u = decodeUser(localStorage.getItem('aff_token') || ''); if (!u) return;
    const amt = Number(wdAmount);
    if (!(amt > 0)) { toast.error('กรุณาระบุจำนวนเงิน'); return; }
    try {
      const res = await instance.post('/api/v1/affwithdrawrequest', { System: API.SYSTEM, affusername: u, amount: amt, method: wdMethod });
      const ok = res.data && res.data.status === 200;
      if (ok) { toast.success((res.data && res.data.message) || 'ส่งคำขอถอนเรียบร้อย'); setWdAmount(''); loadWallet(); loadWdHistory(1); }
      else toast.error((res.data && res.data.message) || 'ไม่สำเร็จ');
    } catch (e) { toast.error('เชื่อมต่อไม่สำเร็จ'); }
  };

  useEffect(() => {
    if (isDash) {
      if (!localStorage.getItem('aff_token')) { navigate('/affiliate/login'); return; }
      loadDash();
    }
  }, [isDash, loadDash, navigate]);

  useEffect(() => {
    if (!isDash) return;
    if (dpage === 'withdraw') { setWalletMsg(null); loadWallet(); loadWdHistory(1); }
    else if (dpage === 'bank') { setWalletMsg(null); loadWallet(); }
    else if (dpage === 'promotion') { loadPromos(); }
    else if (dpage === 'reflink') { loadReflink(); }
    else if (dpage === 'byproduct') { loadByProduct(); }
    else if (dpage === 'subaff') { loadSubaff(); loadSummary(); }
    else if (dpage === 'profile') { setPwdMsg(null); }
    else if (dpage === 'overview' || dpage === 'commission') { loadSummary(); }
  }, [dpage, isDash, loadWallet, loadWdHistory, loadPromos, loadReflink, loadByProduct, loadSubaff, loadSummary]);

  // ทำให้พอร์ทัลเต็มจอ (ตัด padding/max-width ของ layout เว็บหลักเฉพาะหน้า /affiliate)
  useEffect(() => {
    const root = document.querySelector('.affroot');
    const el = document.querySelector('.padding-nav-app') || (root && root.parentElement);
    if (!el) return undefined;
    const prev = { pt: el.style.paddingTop, mw: el.style.maxWidth, w: el.style.width, m: el.style.margin, pl: el.style.paddingLeft, pr: el.style.paddingRight };
    el.style.paddingTop = '0px';
    el.style.paddingLeft = '0px';
    el.style.paddingRight = '0px';
    el.style.maxWidth = 'none';
    el.style.width = '100%';
    el.style.margin = '0';
    return () => { el.style.paddingTop = prev.pt; el.style.maxWidth = prev.mw; el.style.width = prev.w; el.style.margin = prev.m; el.style.paddingLeft = prev.pl; el.style.paddingRight = prev.pr; };
  }, []);

  const doLogin = async () => {
    if (!lg.u || !lg.p) { toast.error('กรุณากรอกชื่อผู้ใช้และรหัสผ่าน'); return; }
    try {
      const res = await instance.post('/api/v1/afflogin', { userid: lg.u, password: lg.p, Prefix: API.SYSTEM, username: lg.u, System: API.SYSTEM });
      const d = res.data || {};
      if (d.status === 200 && d.token) { localStorage.setItem('aff_token', d.token); setToken(d.token); setLoginErr(''); toast.success('เข้าสู่ระบบสำเร็จ'); navigate('/affiliate/dashboard'); }
      else if (d.status === 202) { setLoginErr('บัญชีนี้ยังไม่เปิดใช้งาน (รอแอดมินอนุมัติ)'); toast.warning('บัญชีนี้ยังไม่เปิดใช้งาน (รอแอดมินอนุมัติ)'); }
      else if (d.status === 203) { setLoginErr('บัญชีถูกล็อก กรุณาติดต่อแอดมิน'); toast.error('บัญชีถูกล็อก กรุณาติดต่อแอดมิน'); }
      else { setLoginErr('ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง'); toast.error('ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง'); }
    } catch (e) { setLoginErr('เชื่อมต่อไม่สำเร็จ'); toast.error('เชื่อมต่อไม่สำเร็จ'); }
  };

  const doRegister = async () => {
    if (!reg.name) return toast.error('กรุณากรอกชื่อจริง-นามสกุล');
    if ((reg.user || '').length < 4) return toast.error('username อย่างน้อย 4 ตัวอักษร');
    if ((reg.pass || '').length < 6) return toast.error('รหัสผ่านอย่างน้อย 6 ตัวอักษร');
    if (!/[a-zA-Z]/.test(reg.pass) || !/[0-9]/.test(reg.pass)) return toast.error('รหัสผ่านต้องมีทั้งตัวอักษรและตัวเลข');
    if (reg.pass !== reg.pass2) return toast.error('รหัสผ่านยืนยันไม่ตรงกัน');
    if (!reg.email) return toast.error('กรุณากรอกอีเมล');
    if (!reg.line && !reg.tg && !reg.teams) return toast.error('กรอกช่องทางติดต่ออย่างน้อย 1 รายการ (Line/Telegram/Teams)');
    if (!reg.secq || !reg.seca) return toast.error('เลือกคำถามและกรอกคำตอบความปลอดภัย');
    if (!reg.agree) return toast.error('กรุณายอมรับข้อกำหนดและเงื่อนไข');
    setRegLoading(true);
    try {
      const res = await instance.post('/api/v1/affselfregister', {
        System: API.SYSTEM, affusername: reg.user, password: reg.pass, fullname: reg.name, email: reg.email,
        phone: reg.phone, lineid: reg.line, telegramid: reg.tg, teamsid: reg.teams, contacttime: reg.time,
        secquestion: reg.secq, secanswer: reg.seca, refcode: reg.ref,
        bankid: reg.bankid, accountno: reg.accountno, accountname: reg.accountname,
        walletnetwork: reg.wnet, walletaddress: reg.waddr
      });
      const d = res.data || {};
      if (d.status === 200) { toast.success(d.message || 'สมัครพันธมิตรสำเร็จ รอแอดมินอนุมัติ'); setShowReg(false); }
      else if (d.status === 208) toast.info(d.message || 'คุณสมัครพันธมิตรอยู่แล้ว');
      else toast.error(d.message || 'สมัครไม่สำเร็จ');
    } catch (e) { toast.error('เชื่อมต่อไม่สำเร็จ'); }
    setRegLoading(false);
  };

  const logout = () => { localStorage.removeItem('aff_token'); setToken(''); navigate('/affiliate'); };
  const scrollLogin = () => { const e = document.getElementById('aff-loginsec'); if (e) e.scrollIntoView({ behavior: 'smooth' }); };

  // ===== DASHBOARD VIEW =====
  if (isDash) {
    const o = (dash && dash.overview) || {};
    const a = (dash && dash.affiliate) || {};
    const members = (dash && dash.members) || [];
    return (
      <div className="affroot"><style>{CSS}</style>
        <header className="aff-header"><div className="aff-wrap aff-nav">
          <img src="/aff/logo.png" alt="NOAR" style={{ height: 44 }} />
          <div style={{ flex: 1 }} />
          <span style={{ color: '#ffd9d9', fontSize: 14 }}>{a.username || ''}</span>
          <button className="aff-btn aff-ghost" onClick={logout}>ออกจากระบบ</button>
        </div></header>
        <div className="aff-layout">
          <nav className="aff-side">
            {[['overview', 'ภาพรวม'], ['network', 'เครือข่าย'], ['subaff', 'พันธมิตรลูกสาย'], ['reflink', 'ลิงก์แนะนำ'], ['commission', 'ค่าคอมมิชชั่น'], ['report', 'รายงาน'], ['byproduct', 'รายงานผลิตภัณฑ์'], ['withdraw', 'ถอนเงิน'], ['bank', 'บัญชีธนาคาร'], ['promotion', 'โปรโมชั่น'], ['profile', 'โปรไฟล์']].map((m) => (
              <a key={m[0]} className={dpage === m[0] ? 'active' : ''} onClick={() => setDpage(m[0])}># {m[1]}</a>
            ))}
          </nav>
          <div>
            {dpage === 'overview' && (
              <div>
                <h2 style={{ marginBottom: 16 }}>ภาพรวมเครือข่าย</h2>
                <div className="aff-cards">
                  <div className="aff-stat"><div className="lb">สมาชิกในเครือข่าย</div><div className="vl">{o.totalMembers || 0}</div></div>
                  <div className="aff-stat"><div className="lb">ผู้เล่นผ่านเกณฑ์</div><div className="vl gold">{o.activePlayers || 0}</div></div>
                  <div className="aff-stat"><div className="lb">พันธมิตรลูกสาย</div><div className="vl">{o.subAffiliates || 0}</div></div>
                  <div className="aff-stat"><div className="lb">ส่วนแบ่งของคุณ</div><div className="vl gold">{a.affpercent || 0}%</div></div>
                </div>
                <div className="aff-cards" style={{ marginTop: 14 }}>
                  <div className="aff-stat"><div className="lb">ยอดฝากเครือข่าย</div><div className="vl">{fmt(o.netDeposit)}</div></div>
                  <div className="aff-stat"><div className="lb">ยอดถอนเครือข่าย</div><div className="vl">{fmt(o.netWithdraw)}</div></div>
                  <div className="aff-stat"><div className="lb">ยอดเสียสุทธิ</div><div className="vl">{fmt(o.netWinloss)}</div></div>
                  <div className="aff-stat"><div className="lb">รายได้ที่ถอนได้</div><div className="vl green">{fmt(o.commissionPending)}</div></div>
                </div>
                <div className="aff-card" style={{ marginTop: 16 }}>
                  <b>ค่าคอมมิชชั่น</b>
                  <div className="aff-cards" style={{ marginTop: 12 }}>
                    <div className="aff-stat"><div className="lb">จ่ายแล้ว</div><div className="vl green">{fmt(o.commissionPaid)}</div></div>
                    <div className="aff-stat"><div className="lb">รอจ่าย</div><div className="vl gold">{fmt(o.commissionPending)}</div></div>
                    <div className="aff-stat"><div className="lb">รวมทั้งหมด</div><div className="vl">{fmt(o.commissionTotal)}</div></div>
                    <div className="aff-stat"><div className="lb">เกณฑ์ active</div><div className="vl" style={{ fontSize: 17 }}>{dash && dash.threshold > 0 ? fmt(dash.threshold) + ' (' + (dash.activeMode === 'turnover' ? 'เทิร์น' : 'ฝาก') + ')' : 'ไม่กำหนด'}</div></div>
                  </div>
                </div>
              </div>
            )}
            {dpage === 'network' && (
              <div>
                <h2 style={{ marginBottom: 16 }}>เครือข่ายของฉัน</h2>
                <div className="aff-card">
                  <div style={{ overflowX: 'auto' }}>
                    <table className="aff-tb" style={{ fontSize: 14 }}>
                      <thead><tr><th style={{ textAlign: 'left' }}>สมาชิก</th><th>ยอดฝาก</th><th>ยอดถอน</th><th>ยอดเสียสุทธิ</th><th>เทิร์น</th><th>สถานะ</th></tr></thead>
                      <tbody>
                        {members.length ? members.map((x, i) => (
                          <tr key={i}><td style={{ textAlign: 'left' }}>{x.playerid}</td><td>{fmt(x.deposit)}</td><td>{fmt(x.withdraw)}</td><td>{fmt(x.winloss)}</td><td>{fmt(x.turnover)}</td>
                            <td><span className={'aff-badge ' + (x.active ? 'on' : 'off')}>{x.active ? 'ผ่านเกณฑ์' : '-'}</span></td></tr>
                        )) : (<tr><td colSpan={6} style={{ color: 'var(--muted)' }}>ไม่มีสมาชิก</td></tr>)}
                      </tbody>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 12 }}>
                    <button className="aff-btn aff-ghost" onClick={() => { if (netPage > 1) setNetPage(netPage - 1); }}>ก่อนหน้า</button>
                    <small style={{ color: 'var(--muted)' }}>หน้า {dash ? dash.page : 1}/{dash ? dash.totalPages : 1} (ทั้งหมด {dash ? dash.total : 0} คน)</small>
                    <button className="aff-btn aff-ghost" onClick={() => { if (dash && netPage < dash.totalPages) setNetPage(netPage + 1); }}>ถัดไป</button>
                  </div>
                </div>
              </div>
            )}
            {dpage === 'commission' && (
              <div>
                <h2 style={{ marginBottom: 16 }}>ค่าคอมมิชชั่น &amp; ระดับ</h2>
                {summary ? (
                  <>
                    {/* ระดับปัจจุบัน + ความคืบหน้า */}
                    <div className="aff-card" style={{ marginBottom: 16 }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
                        <div>
                          <div style={{ color: 'var(--muted)', fontSize: 13 }}>ระดับปัจจุบัน</div>
                          <div style={{ fontSize: 26, fontWeight: 900, color: 'var(--gold)' }}>{summary.tier.currentName}</div>
                        </div>
                        <div style={{ textAlign: 'right' }}>
                          <div style={{ color: 'var(--muted)', fontSize: 13 }}>ค่าคอมของคุณ</div>
                          <div style={{ fontSize: 26, fontWeight: 900 }}>{summary.tier.currentPercent}%</div>
                        </div>
                      </div>
                      <div style={{ marginTop: 10, fontSize: 14 }}>ยอดเสียเครือข่ายเดือนนี้: <b>{fmt(summary.tier.monthNet)}</b></div>
                      {summary.tier.next ? (
                        <div style={{ marginTop: 8 }}>
                          <div style={{ height: 12, borderRadius: 8, background: 'rgba(255,255,255,.12)', overflow: 'hidden' }}>
                            <div style={{ width: summary.tier.progress + '%', height: '100%', background: 'linear-gradient(90deg,#f59e0b,#fcd34d)' }} />
                          </div>
                          <small style={{ color: 'var(--muted)' }}>อีก <b style={{ color: 'var(--gold)' }}>{fmt(summary.tier.remain)}</b> จะขึ้นระดับ <b>{summary.tier.next.name}</b> (ค่าคอม {summary.tier.next.percent}%)</small>
                        </div>
                      ) : (
                        <small style={{ color: 'var(--gold)' }}>🎉 คุณอยู่ระดับสูงสุดแล้ว</small>
                      )}
                    </div>

                    {/* สรุปค่าคอม/ค้างจ่าย */}
                    <div className="aff-cards" style={{ marginBottom: 16 }}>
                      <div className="aff-stat"><div className="lb">รอบจ่าย</div><div className="vl">{summary.payout.cycle === 'daily' ? 'รายวัน' : summary.payout.cycle === 'weekly' ? 'รายอาทิตย์' : 'รายเดือน'}</div></div>
                      <div className="aff-stat"><div className="lb">ค่าคอมค้างจ่าย</div><div className="vl gold">{fmt(summary.payout.totalUnpaid)}</div></div>
                      <div className="aff-stat"><div className="lb">ค่าคอมประมาณเดือนนี้</div><div className="vl">{fmt(summary.overview.commissionEst)}</div></div>
                    </div>

                    {/* รายงานค่าคอมตามรอบ */}
                    <div className="aff-card" style={{ marginBottom: 16 }}>
                      <div className="aff-sub">รายงานค่าคอมตามรอบจ่าย</div>
                      <div style={{ overflowX: 'auto' }}>
                        <table className="aff-tb" style={{ fontSize: 14 }}>
                          <thead><tr><th style={{ textAlign: 'left' }}>งวด</th><th>ยอดเสียสุทธิ</th><th>ค่าคอม</th><th>สถานะ</th></tr></thead>
                          <tbody>
                            {(summary.payout.periods || []).slice(0, 8).map((p, i) => (
                              <tr key={i}>
                                <td style={{ textAlign: 'left' }}>{p.label}</td>
                                <td>{fmt(p.netloss)}</td>
                                <td><b style={{ color: 'var(--gold)' }}>{fmt(p.commission)}</b>{Number(p.carryOut) < 0 ? <div style={{ fontSize: 11, color: '#f87171' }}>ยกไป {fmt(p.carryOut)}</div> : null}</td>
                                <td>{p.closed ? 'ปิดยอดเก่า' : p.paid ? '✅ จ่ายแล้ว' : (p.payable === false ? '⏳ รอสิ้นงวด' : (p.commission > 0 ? '● ค้างจ่าย' : '-'))}</td>
                              </tr>
                            ))}
                            {(!summary.payout.periods || summary.payout.periods.length === 0) && (<tr><td colSpan={4} style={{ color: 'var(--muted)' }}>ยังไม่มีข้อมูล</td></tr>)}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    {/* ส่วนต่างจากใต้สาย */}
                    {summary.spread && summary.spread.subaffiliates && summary.spread.subaffiliates.length > 0 && (
                      <div className="aff-card" style={{ marginBottom: 16 }}>
                        <div className="aff-sub">ส่วนต่างที่ได้จากลูกสาย (เดือนนี้)</div>
                        <div style={{ overflowX: 'auto' }}>
                          <table className="aff-tb" style={{ fontSize: 14 }}>
                            <thead><tr><th style={{ textAlign: 'left' }}>ลูกสาย</th><th>% ลูกสาย</th><th>ส่วนต่าง</th><th>ยอดเสียสาย</th><th>คุณได้เพิ่ม</th></tr></thead>
                            <tbody>
                              {summary.spread.subaffiliates.map((s, i) => (
                                <tr key={i}><td style={{ textAlign: 'left' }}>{s.username}</td><td>{s.subpercent}%</td><td>{s.spread}%</td><td>{fmt(s.netloss)}</td><td><b style={{ color: 'var(--gold)' }}>{fmt(s.override)}</b></td></tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}

                    {/* ตารางระดับทั้งหมด */}
                    <div className="aff-comm">
                      <div className="aff-sub">ตารางระดับทั้งหมด</div>
                      <table className="aff-tb">
                        <thead><tr><th>ระดับ</th><th>ยอดเสียเครือข่าย/เดือน</th><th>ค่าคอมมิชชั่น</th></tr></thead>
                        <tbody>
                          {(summary.tier.tiers && summary.tier.tiers.length > 0) ? summary.tier.tiers.map((tr, i) => (
                            <tr key={i}><td>{tr.name}</td><td>{tr.min > 0 ? 'ตั้งแต่ ' + fmt(tr.min) : 'ไม่จำกัด'}</td><td><b>{tr.percent}%</b></td></tr>
                          )) : (
                            <tr><td colSpan={3} style={{ color: 'var(--muted)' }}>ยังไม่ได้ตั้งค่าระดับ</td></tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </>
                ) : (
                  <div className="aff-comm">
                    <table className="aff-tb">
                      <thead><tr><th>ระดับ</th><th>ยอดเสียเครือข่าย/เดือน</th><th>ค่าคอมมิชชั่น</th></tr></thead>
                      <tbody>
                        <tr><td>เริ่มต้น</td><td>ไม่จำกัด</td><td><b>สูงสุด 25%</b></td></tr>
                        <tr><td>เงิน</td><td>ตั้งแต่ 100,000</td><td><b>สูงสุด 35%</b></td></tr>
                        <tr><td>ทอง</td><td>ตั้งแต่ 500,000</td><td><b>สูงสุด 45%</b></td></tr>
                        <tr><td>แพลทินัม</td><td>ตั้งแต่ 1,000,000</td><td><b>สูงสุด 50%</b></td></tr>
                      </tbody>
                    </table>
                  </div>
                )}
                <small style={{ color: 'var(--muted)' }}>* ส่วนแบ่งจริงของคุณ: <b style={{ color: 'var(--gold)' }}>{a.affpercent || 0}%</b></small>
              </div>
            )}
            {dpage === 'report' && (
              <div>
                <h2 style={{ marginBottom: 16 }}>รายงานตามช่วงเวลา</h2>
                <div className="aff-card">
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr auto', gap: 10, alignItems: 'end' }}>
                    <div><small style={{ color: 'var(--muted)' }}>ตั้งแต่วันที่</small><input className="aff-input" type="date" value={rp.from} onChange={(e) => setRp({ ...rp, from: e.target.value })} /></div>
                    <div><small style={{ color: 'var(--muted)' }}>ถึงวันที่</small><input className="aff-input" type="date" value={rp.to} onChange={(e) => setRp({ ...rp, to: e.target.value })} /></div>
                    <button className="aff-btn aff-gold" onClick={() => { setNetPage(1); loadDash(); }}>ดูรายงาน</button>
                  </div>
                  <div className="aff-cards" style={{ marginTop: 16 }}>
                    <div className="aff-stat"><div className="lb">ยอดฝาก (ช่วงนี้)</div><div className="vl">{fmt(o.netDeposit)}</div></div>
                    <div className="aff-stat"><div className="lb">ยอดถอน (ช่วงนี้)</div><div className="vl">{fmt(o.netWithdraw)}</div></div>
                    <div className="aff-stat"><div className="lb">ยอดเสียสุทธิ</div><div className="vl gold">{fmt(o.netWinloss)}</div></div>
                    <div className="aff-stat"><div className="lb">ผู้เล่นผ่านเกณฑ์</div><div className="vl">{o.activePlayers || 0}</div></div>
                  </div>
                </div>
              </div>
            )}
            {dpage === 'subaff' && (
              <div>
                <h2 style={{ marginBottom: 16 }}>พันธมิตรลูกสาย</h2>
                <div className="aff-card">
                  <div style={{ overflowX: 'auto' }}>
                    <table className="aff-tb" style={{ fontSize: 14 }}>
                      <thead><tr><th style={{ textAlign: 'left' }}>พันธมิตร</th><th style={{ textAlign: 'left' }}>ชื่อ</th><th>สมาชิกในสาย</th><th>ส่วนแบ่ง</th><th>สถานะ</th></tr></thead>
                      <tbody>
                        {subaff.length ? subaff.map((x, i) => (
                          <tr key={i}><td style={{ textAlign: 'left' }}>{x.username}</td><td style={{ textAlign: 'left' }}>{x.fname || '-'}</td><td>{x.members || 0}</td><td>{x.affpercent || 0}%</td>
                            <td><span className={'aff-badge ' + (Number(x.approvestatus) === 1 ? 'on' : 'off')}>{Number(x.approvestatus) === 1 ? 'อนุมัติ' : 'รออนุมัติ'}</span></td></tr>
                        )) : (<tr><td colSpan={5} style={{ color: 'var(--muted)' }}>ยังไม่มีพันธมิตรลูกสาย</td></tr>)}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}
            {dpage === 'reflink' && (
              <div>
                <h2 style={{ marginBottom: 16 }}>ลิงก์แนะนำ</h2>
                <div className="aff-card">
                  <div className="aff-sub">ลิงก์แนะนำของคุณ</div>
                  <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
                    <input className="aff-input" readOnly value={reflink && reflink.link ? reflink.link : ''} style={{ flex: 1, minWidth: 220 }} />
                    <button className="aff-btn aff-gold" onClick={copyLink}>{copied ? 'คัดลอกแล้ว ✓' : 'คัดลอกลิงก์'}</button>
                  </div>
                  <div style={{ marginTop: 8, color: 'var(--muted)', fontSize: 13 }}>รหัสแนะนำ: <b style={{ color: 'var(--gold)' }}>{reflink && reflink.code ? reflink.code : '-'}</b></div>
                  {reflink && reflink.qr ? (
                    <div style={{ marginTop: 16, textAlign: 'center' }}>
                      <div className="aff-sub">QR Code</div>
                      <img src={reflink.qr} alt="QR" style={{ width: 200, height: 200, background: '#fff', borderRadius: 12, padding: 8 }} />
                      <div style={{ color: 'var(--muted)', fontSize: 12, marginTop: 8 }}>ให้ผู้เล่นสแกนเพื่อสมัครผ่านลิงก์ของคุณ</div>
                    </div>
                  ) : null}
                </div>
                <div className="aff-card" style={{ marginTop: 16 }}>
                  <div className="aff-sub">ข้อความชวนสมัคร (คัดลอกไปโพสต์ได้)</div>
                  <textarea className="aff-input" readOnly rows={3} value={reflink && reflink.link ? ('สมัครเล่นกับ NOAR GAME รับโบนัสต้อนรับ! สมัครที่นี่ 👉 ' + reflink.link) : ''} />
                </div>
              </div>
            )}
            {dpage === 'byproduct' && (
              <div>
                <h2 style={{ marginBottom: 16 }}>รายงานแยกตามผลิตภัณฑ์</h2>
                <div className="aff-card">
                  <div className="aff-sub">ยอดเทิร์นสะสมของเครือข่าย (แยกตามผลิตภัณฑ์)</div>
                  <div style={{ overflowX: 'auto' }}>
                    <table className="aff-tb" style={{ fontSize: 14 }}>
                      <thead><tr><th style={{ textAlign: 'left' }}>ผลิตภัณฑ์</th><th>จำนวนผู้เล่น</th><th>ยอดเทิร์นรวม</th></tr></thead>
                      <tbody>
                        {byproduct && byproduct.products ? byproduct.products.map((p, i) => (
                          <tr key={i}><td style={{ textAlign: 'left' }}>{p.product}</td><td>{p.players || 0}</td><td>{fmt(p.turnover)}</td></tr>
                        )) : (<tr><td colSpan={3} style={{ color: 'var(--muted)' }}>ไม่มีข้อมูล</td></tr>)}
                      </tbody>
                    </table>
                  </div>
                  <small style={{ color: 'var(--muted)', display: 'block', marginTop: 10 }}>* ยอดเทิร์นเป็นค่าสะสมทั้งหมดของสมาชิกในเครือข่าย ({byproduct ? byproduct.totalMembers : 0} คน)</small>
                </div>
              </div>
            )}
            {dpage === 'withdraw' && (
              <div>
                <h2 style={{ marginBottom: 16 }}>ถอนเงิน</h2>
                <div className="aff-cards">
                  <div className="aff-stat"><div className="lb">ยอดที่ถอนได้</div><div className="vl green">{fmt(wallet && wallet.balance ? wallet.balance.withdrawable : 0)}</div></div>
                  <div className="aff-stat"><div className="lb">รอจ่าย (ค่าคอม)</div><div className="vl gold">{fmt(wallet && wallet.balance ? wallet.balance.pending : 0)}</div></div>
                  <div className="aff-stat"><div className="lb">จ่ายแล้วสะสม</div><div className="vl">{fmt(wallet && wallet.balance ? wallet.balance.paid : 0)}</div></div>
                  <div className="aff-stat"><div className="lb">คำขอค้างอยู่</div><div className="vl">{fmt(wallet && wallet.balance ? wallet.balance.requested : 0)}</div></div>
                </div>
                <div className="aff-card" style={{ marginTop: 16 }}>
                  <div className="aff-sub">แจ้งถอนรายได้</div>
                  {walletMsg && <div className={'aff-msg ' + (walletMsg.ok ? 'ok' : 'err')}>{walletMsg.t}</div>}
                  <div style={{ display: 'grid', gridTemplateColumns: '160px 1fr auto', gap: 10, alignItems: 'end' }}>
                    <div><label style={{ fontSize: 13, color: 'var(--muted)', display: 'block', marginBottom: 5 }}>ช่องทาง</label>
                      <select className="aff-input" value={wdMethod} onChange={(e) => setWdMethod(e.target.value)}>
                        <option value="bank">โอนเข้าบัญชีธนาคาร</option>
                        <option value="crypto">กระเป๋าคริปโต (USDT)</option>
                      </select>
                    </div>
                    <div><label style={{ fontSize: 13, color: 'var(--muted)', display: 'block', marginBottom: 5 }}>จำนวนเงิน</label>
                      <input className="aff-input" type="number" min="0" value={wdAmount} onChange={(e) => setWdAmount(e.target.value)} placeholder="0.00" /></div>
                    <button className="aff-btn aff-gold" onClick={submitWithdraw}>แจ้งถอน</button>
                  </div>
                  <small style={{ color: 'var(--muted)', display: 'block', marginTop: 10 }}>
                    ปลายทาง: {wdMethod === 'crypto'
                      ? ((wallet && wallet.profile && wallet.profile.walletaddress) ? (wallet.profile.walletnetwork + ' : ' + wallet.profile.walletaddress) : 'ยังไม่ตั้งค่ากระเป๋า')
                      : ((wallet && wallet.profile && wallet.profile.accountno) ? ((wallet.profile.bankname || '') + ' ' + wallet.profile.accountno) : 'ยังไม่ตั้งค่าบัญชี')}
                    {' '}(แก้ไขได้ที่เมนู “บัญชีธนาคาร”)
                  </small>
                </div>
                <div className="aff-card" style={{ marginTop: 16 }}>
                  <div className="aff-sub">ประวัติการถอน / การจ่ายค่าคอม</div>
                  <div style={{ overflowX: 'auto' }}>
                    <table className="aff-tb" style={{ fontSize: 14 }}>
                      <thead><tr><th style={{ textAlign: 'left' }}>วันที่</th><th style={{ textAlign: 'left' }}>ประเภท</th><th style={{ textAlign: 'left' }}>ช่องทาง/บัญชี</th><th>จำนวน</th><th>สถานะ</th></tr></thead>
                      <tbody>
                        {wdList.length ? wdList.map((x, i) => (
                          <tr key={i}>
                            <td style={{ textAlign: 'left' }}>{x.created ? String(x.created).slice(0, 19).replace('T', ' ') : '-'}</td>
                            <td style={{ textAlign: 'left' }}>{x.source === 'request' ? 'คำขอถอน' : 'จ่ายค่าคอม'}</td>
                            <td style={{ textAlign: 'left' }}>{x.account || x.note || '-'}</td>
                            <td>{fmt(x.amount)}</td>
                            <td><span className={'aff-badge ' + (Number(x.status) === 1 ? 'on' : 'off')}>{Number(x.status) === 1 ? 'สำเร็จ' : (Number(x.status) === 2 ? 'ปฏิเสธ' : 'รอดำเนินการ')}</span></td>
                          </tr>
                        )) : (<tr><td colSpan={5} style={{ color: 'var(--muted)' }}>ยังไม่มีรายการ</td></tr>)}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}
            {dpage === 'bank' && (
              <div>
                <h2 style={{ marginBottom: 16 }}>บัญชีธนาคาร / กระเป๋า</h2>
                <div className="aff-card">
                  {walletMsg && <div className={'aff-msg ' + (walletMsg.ok ? 'ok' : 'err')}>{walletMsg.t}</div>}
                  <div className="aff-sub">บัญชีธนาคาร (รับเงินค่าคอม)</div>
                  <div className="aff-row2">
                    <div className="aff-field"><label>ธนาคาร</label>
                      <select className="aff-input" value={wform.bankid} onChange={(e) => setWform({ ...wform, bankid: e.target.value })}>
                        <option value="">เลือกธนาคาร</option>
                        {(wallet && wallet.banks ? wallet.banks : []).map((b) => (
                          <option key={b.bank_id} value={b.bank_id}>{b.fullname_th || b.acro}</option>
                        ))}
                      </select>
                    </div>
                    <div className="aff-field"><label>เลขที่บัญชี</label><input className="aff-input" value={wform.accountno} onChange={(e) => setWform({ ...wform, accountno: e.target.value })} /></div>
                  </div>
                  <div className="aff-field"><label>ชื่อบัญชี</label><input className="aff-input" value={wform.accountname} onChange={(e) => setWform({ ...wform, accountname: e.target.value })} /></div>
                  <div className="aff-sub" style={{ marginTop: 8 }}>กระเป๋าคริปโต (ทางเลือก)</div>
                  <div className="aff-row2">
                    <div className="aff-field"><label>เครือข่าย</label>
                      <select className="aff-input" value={wform.walletnetwork} onChange={(e) => setWform({ ...wform, walletnetwork: e.target.value })}>
                        <option value="TRC20">USDT — TRON (TRC20)</option>
                        <option value="ERC20">USDT — Ethereum (ERC20)</option>
                      </select>
                    </div>
                    <div className="aff-field"><label>ที่อยู่กระเป๋า (Wallet Address)</label><input className="aff-input" value={wform.walletaddress} onChange={(e) => setWform({ ...wform, walletaddress: e.target.value })} /></div>
                  </div>
                  <button className="aff-btn aff-gold" style={{ marginTop: 6 }} onClick={saveBank}>บันทึกข้อมูลบัญชี</button>
                </div>
              </div>
            )}
            {dpage === 'promotion' && (
              <div>
                <h2 style={{ marginBottom: 16 }}>โปรโมชั่น / สื่อโปรโมท</h2>
                {promos.length ? (
                  <div className="aff-grid3">
                    {promos.map((p) => (
                      <div className="aff-card" key={p.no} style={{ padding: 0, overflow: 'hidden' }}>
                        {p.linkpicture ? <img src={p.linkpicture} alt={p.proname || ''} style={{ width: '100%', display: 'block' }} onError={(e) => { e.target.style.display = 'none'; }} /> : null}
                        <div style={{ padding: 16 }}>
                          <h3 style={{ fontSize: 16, margin: '0 0 6px' }}>{p.proname || '-'}</h3>
                          <p style={{ color: 'var(--muted)', fontSize: 13, margin: 0 }}>{p.subtitle || ''}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (<div className="aff-card" style={{ color: 'var(--muted)' }}>ยังไม่มีโปรโมชั่น</div>)}
              </div>
            )}
            {dpage === 'profile' && (
              <div>
                <h2 style={{ marginBottom: 16 }}>โปรไฟล์พันธมิตร</h2>
                <div className="aff-card" style={{ lineHeight: 2.2 }}>
                  <div>ชื่อ: <b>{a.fname || '-'}</b></div>
                  <div>Username: <b>{a.username || '-'}</b></div>
                  <div>ส่วนแบ่งค่าคอม: <b style={{ color: 'var(--gold)' }}>{a.affpercent || 0}%</b></div>
                  <div>สถานะ: <b>{a.approved ? 'อนุมัติแล้ว' : 'รออนุมัติ'}</b></div>
                </div>
                <div className="aff-card" style={{ marginTop: 16 }}>
                  <div className="aff-sub">เปลี่ยนรหัสผ่าน</div>
                  {pwdMsg && <div className={'aff-msg ' + (pwdMsg.ok ? 'ok' : 'err')}>{pwdMsg.t}</div>}
                  <div className="aff-field"><label>รหัสผ่านเดิม</label><input className="aff-input" type="password" autoComplete="off" value={pwd.old} onChange={(e) => setPwd({ ...pwd, old: e.target.value })} /></div>
                  <div className="aff-row2">
                    <div className="aff-field"><label>รหัสผ่านใหม่</label><input className="aff-input" type="password" autoComplete="new-password" value={pwd.n1} onChange={(e) => setPwd({ ...pwd, n1: e.target.value })} /></div>
                    <div className="aff-field"><label>ยืนยันรหัสผ่านใหม่</label><input className="aff-input" type="password" autoComplete="new-password" value={pwd.n2} onChange={(e) => setPwd({ ...pwd, n2: e.target.value })} /></div>
                  </div>
                  <button className="aff-btn aff-gold" onClick={changePwd}>บันทึกรหัสผ่านใหม่</button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  // ===== LOGIN PAGE (dedicated) =====
  if (isLogin) {
    return (
      <div className="affroot"><style>{CSS}</style>
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
          <div className="aff-logincard" style={{ width: '100%', maxWidth: 420, background: 'var(--card)', border: '1px solid var(--line)', borderRadius: 16, padding: 28 }}>
            <div style={{ textAlign: 'center', marginBottom: 18 }}>
              <img src="/aff/logo.png" alt="NOAR" style={{ height: 60 }} />
              <div style={{ color: 'var(--gold)', fontWeight: 800, fontSize: 13, letterSpacing: 1, marginTop: 6 }}>AFFILIATE</div>
            </div>
            <div style={{ textAlign: 'center', color: 'var(--muted)', fontSize: 14, marginBottom: 16 }}>เข้าสู่ระบบพันธมิตร</div>
            {loginErr && <div className="aff-msg err">{loginErr}</div>}
            <div className="aff-field"><label>ชื่อผู้ใช้</label><span className="aff-inw -user"><input className="aff-input" autoComplete="off" value={lg.u} onChange={(e) => setLg({ ...lg, u: e.target.value })} onKeyDown={(e) => { if (e.key === 'Enter') doLogin(); }} /></span></div>
            <div className="aff-field"><label>รหัสผ่าน</label><span className="aff-inw -lock"><input className="aff-input" type="password" autoComplete="off" value={lg.p} onChange={(e) => setLg({ ...lg, p: e.target.value })} onKeyDown={(e) => { if (e.key === 'Enter') doLogin(); }} /></span></div>
            <button className="aff-btn aff-gold" style={{ width: '100%', marginTop: 6 }} onClick={doLogin}>เข้าสู่ระบบ</button>
            <div style={{ textAlign: 'center', marginTop: 14, color: 'var(--muted)', fontSize: 13 }}>
              ยังไม่มีบัญชี? <a style={{ color: 'var(--gold)', cursor: 'pointer' }} onClick={() => navigate('/affiliate')}>สมัครพันธมิตร</a>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // ===== LANDING VIEW =====
  return (
    <div className="affroot"><style>{CSS}</style>
      <header className="aff-header"><div className="aff-wrap aff-nav" style={{ paddingLeft: 8 }}>
        <img src="/aff/logo.png" alt="NOAR" style={{ height: 44, marginLeft: -4, marginRight: 14 }} />
        <span style={{ fontSize: 15, color: 'var(--gold)', fontWeight: 800 }}>AFFILIATE</span>
        <nav className="aff-menu">
          <a onClick={() => document.getElementById('why').scrollIntoView({ behavior: 'smooth' })}>ทำไมต้องร่วมกับเรา</a>
          <a onClick={() => document.getElementById('how').scrollIntoView({ behavior: 'smooth' })}>เข้าร่วมอย่างไร</a>
          <a onClick={() => document.getElementById('commission').scrollIntoView({ behavior: 'smooth' })}>แผนค่าคอมมิชชั่น</a>
        </nav>
        <div className="aff-loginmini">
          <span className="aff-inw -user"><input className="aff-input" placeholder="ชื่อผู้ใช้" value={lg.u} onChange={(e) => setLg({ ...lg, u: e.target.value })} /></span>
          <span className="aff-inw -lock"><input className="aff-input" type="password" placeholder="รหัสผ่าน" value={lg.p} onChange={(e) => setLg({ ...lg, p: e.target.value })} /></span>
          <button className="aff-btn aff-ghost" onClick={doLogin}>เข้าสู่ระบบ</button>
          <button className="aff-btn aff-gold" onClick={() => { setRegMsg(null); setShowReg(true); }}>ลงทะเบียน</button>
        </div>
      </div></header>

      <div className="aff-hero">
        <img src="/aff/cover.png" alt="โปรแกรมพันธมิตร NOAR GAME" style={{ width: '100%', display: 'block' }} />
        <div className="aff-cta">
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
            <button className="aff-btn aff-gold" style={{ fontSize: 17, padding: '14px 32px' }} onClick={() => { setRegMsg(null); setShowReg(true); }}>สมัครเป็นพันธมิตรฟรี</button>
            <button className="aff-btn aff-ghost" style={{ fontSize: 17, padding: '14px 26px' }} onClick={() => navigate('/affiliate/login')}>เข้าสู่ระบบ</button>
          </div>
          <div className="aff-stats">
            <div><b>50%</b><small>ค่าคอมสูงสุด</small></div>
            <div><b>รายสัปดาห์</b><small>รอบจ่ายจริง</small></div>
            <div><b>24/7</b><small>ทีมซัพพอร์ต</small></div>
          </div>
        </div>
      </div>

      <div id="aff-loginsec" style={{ background: 'var(--bg2)', borderBottom: '1px solid var(--line)' }}>
        <div className="aff-wrap" style={{ maxWidth: 520, padding: '26px 20px' }}>
          <div className="aff-sub" style={{ textAlign: 'center' }}>เข้าสู่ระบบพันธมิตร</div>
          <div className="aff-row2">
            <div className="aff-field"><span className="aff-inw -user"><input className="aff-input" placeholder="ชื่อผู้ใช้" value={lg.u} onChange={(e) => setLg({ ...lg, u: e.target.value })} /></span></div>
            <div className="aff-field"><span className="aff-inw -lock"><input className="aff-input" type="password" placeholder="รหัสผ่าน" value={lg.p} onChange={(e) => setLg({ ...lg, p: e.target.value })} /></span></div>
          </div>
          <button className="aff-btn aff-gold" style={{ width: '100%' }} onClick={doLogin}>เข้าสู่ระบบ</button>
          <div style={{ textAlign: 'center', marginTop: 12, color: 'var(--muted)', fontSize: 13 }}>ยังไม่มีบัญชี? <a style={{ color: 'var(--gold)', cursor: 'pointer' }} onClick={() => { setRegMsg(null); setShowReg(true); }}>ลงทะเบียนที่นี่</a></div>
        </div>
      </div>

      <section id="why" className="aff-sec"><div className="aff-wrap">
        <div className="aff-sectitle"><h2>ทำไมต้องร่วมเป็นพันธมิตรกับเรา</h2><p>ผลตอบแทนคุ้มค่า ระบบโปร่งใส</p></div>
        <div className="aff-grid3">
          <div className="aff-card"><div className="ico">%</div><h3>ค่าคอมสูงสุด 50%</h3><p>รับส่วนแบ่งจากยอดเสียของสมาชิกในเครือข่ายของคุณ</p></div>
          <div className="aff-card"><div className="ico">↻</div><h3>จ่ายจริงสม่ำเสมอ</h3><p>คำนวณและจ่ายค่าคอมทุกสัปดาห์ ถอนได้ตลอด</p></div>
          <div className="aff-card"><div className="ico">▤</div><h3>รายงานเรียลไทม์</h3><p>ดูยอดเครือข่าย ฝาก-ถอน และรายได้แบบเรียลไทม์</p></div>
        </div>
      </div></section>

      <section id="how" className="aff-sec" style={{ background: 'var(--bg2)' }}><div className="aff-wrap">
        <div className="aff-sectitle"><h2>เข้าร่วมอย่างไร</h2><p>เริ่มง่ายๆ 3 ขั้นตอน</p></div>
        <div className="aff-grid3">
          <div className="aff-card"><h3>1. ลงทะเบียน</h3><p>กรอกข้อมูลสมัครเป็นพันธมิตร ไม่ถึง 2 นาที</p></div>
          <div className="aff-card"><h3>2. รับลิงก์แนะนำ</h3><p>หลังอนุมัติ รับลิงก์และเครื่องมือโปรโมท</p></div>
          <div className="aff-card"><h3>3. รับรายได้</h3><p>ทุกยอดเสียเครือข่ายกลายเป็นรายได้ ถอนได้ทุกสัปดาห์</p></div>
        </div>
      </div></section>

      <section id="commission" className="aff-sec"><div className="aff-wrap">
        <div className="aff-sectitle"><h2>แผนค่าคอมมิชชั่น</h2><p>ยิ่งเครือข่ายใหญ่ ค่าคอมยิ่งสูง</p></div>
        <div className="aff-comm"><table className="aff-tb">
          <thead><tr><th>ระดับ</th><th>ยอดเสียเครือข่าย/เดือน</th><th>ค่าคอมมิชชั่น</th><th></th></tr></thead>
          <tbody>
            {COMM_TIERS.map((t) => (
              <tr key={t.key}>
                <td><span style={{ color: t.color, fontWeight: 700 }}>{t.name}</span></td>
                <td>{t.range}</td>
                <td><b>{t.rate}</b></td>
                <td style={{ textAlign: 'right' }}>
                  <button className="aff-btn aff-ghost" style={{ padding: '6px 14px', fontSize: 13 }} onClick={() => setCommDetail(t)}>รายละเอียด</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table></div>
      </div></section>

      {commDetail && (
        <div className="aff-overlay" onClick={(e) => { if (e.target.className === 'aff-overlay') setCommDetail(null); }}>
          <div className="aff-modal" style={{ maxWidth: 460 }}>
            <div className="aff-modal-h">
              <h3 style={{ fontSize: 18 }}>ระดับ<span style={{ color: commDetail.color, marginLeft: 6 }}>{commDetail.name}</span></h3>
              <div className="x" onClick={() => setCommDetail(null)}>×</div>
            </div>
            <div className="aff-modal-b">
              <div style={{ display: 'flex', justifyContent: 'space-between', background: 'var(--bg2)', border: '1px solid var(--line)', borderRadius: 10, padding: '12px 14px', marginBottom: 14 }}>
                <div><div style={{ fontSize: 12, color: 'var(--muted)' }}>เงื่อนไขยอดเสียเครือข่าย/เดือน</div><div style={{ fontWeight: 700 }}>{commDetail.range}</div></div>
                <div style={{ textAlign: 'right' }}><div style={{ fontSize: 12, color: 'var(--muted)' }}>ค่าคอมสูงสุด</div><div style={{ fontWeight: 800, color: 'var(--gold)' }}>{commDetail.rate}</div></div>
              </div>
              <div className="aff-sub">อัตราค่าคอมตามยอดเสีย</div>
              <table className="aff-tb" style={{ marginBottom: 14 }}>
                <thead><tr><th>ยอดเสียเครือข่าย/เดือน</th><th style={{ textAlign: 'right' }}>ค่าคอมมิชชั่น</th></tr></thead>
                <tbody>
                  {commDetail.tiers.map((row, i) => (
                    <tr key={i}><td>{row[0]}</td><td style={{ textAlign: 'right' }}><b>{row[1]}</b></td></tr>
                  ))}
                </tbody>
              </table>
              <div className="aff-sub">สิทธิประโยชน์</div>
              <ul style={{ margin: '6px 0 0', paddingLeft: 18, lineHeight: 1.8 }}>
                {commDetail.benefits.map((b, i) => (<li key={i}>{b}</li>))}
              </ul>
              <button className="aff-btn aff-gold" style={{ width: '100%', marginTop: 18 }} onClick={() => { setCommDetail(null); setRegMsg(null); setShowReg(true); }}>สมัครเป็นพันธมิตรฟรี</button>
            </div>
          </div>
        </div>
      )}

      <footer className="aff-footer"><div className="aff-wrap">© 2026 NOAR GAME Affiliate — โปรแกรมพันธมิตร</div></footer>

      {showReg && (
        <div className="aff-overlay" onClick={(e) => { if (e.target.className === 'aff-overlay') setShowReg(false); }}>
          <div className="aff-modal">
            <div className="aff-modal-h"><h3 style={{ fontSize: 18 }}>ลงทะเบียนเป็นพันธมิตร</h3><div className="x" onClick={() => setShowReg(false)}>×</div></div>
            <div className="aff-modal-b">
              {regMsg && <div className={'aff-msg ' + (regMsg.ok ? 'ok' : 'err')}>{regMsg.t}</div>}
              <div className="aff-sub">ข้อมูลบัญชี</div>
              <div className="aff-row2">
                <div className="aff-field"><label>ชื่อจริง-นามสกุล *</label><input className="aff-input" autoComplete="off" value={reg.name} onChange={(e) => setR('name', e.target.value)} /></div>
                <div className="aff-field"><label>ยูสเซอร์เนม *</label><input className="aff-input" autoComplete="off" value={reg.user} onChange={(e) => setR('user', e.target.value)} /></div>
                <div className="aff-field"><label>รหัสผ่าน *</label><input className="aff-input" type="password" autoComplete="new-password" value={reg.pass} onChange={(e) => setR('pass', e.target.value)} /></div>
                <div className="aff-field"><label>ยืนยันรหัสผ่าน *</label><input className="aff-input" type="password" autoComplete="new-password" value={reg.pass2} onChange={(e) => setR('pass2', e.target.value)} /></div>
              </div>
              <div className="aff-sub">ข้อมูลติดต่อ</div>
              <div className="aff-row2">
                <div className="aff-field"><label>เบอร์โทรศัพท์</label><input className="aff-input" autoComplete="off" value={reg.phone} onChange={(e) => setR('phone', e.target.value)} /></div>
                <div className="aff-field"><label>อีเมล *</label><input className="aff-input" type="email" autoComplete="off" value={reg.email} onChange={(e) => setR('email', e.target.value)} /></div>
              </div>
              <div className="aff-field"><label>ช่องทางติดต่อหลัก (อย่างน้อย 1) *</label>
                <input className="aff-input" style={{ marginBottom: 8 }} placeholder="Line ID" value={reg.line} onChange={(e) => setR('line', e.target.value)} />
                <input className="aff-input" style={{ marginBottom: 8 }} placeholder="Telegram ID" value={reg.tg} onChange={(e) => setR('tg', e.target.value)} />
                <input className="aff-input" placeholder="Teams ID" value={reg.teams} onChange={(e) => setR('teams', e.target.value)} />
              </div>
              <div className="aff-sub">บัญชีรับเงินค่าคอมมิชชั่น</div>
              <div className="aff-row2">
                <div className="aff-field"><label>ธนาคาร</label>
                  <select className="aff-input" value={reg.bankid} onChange={(e) => setR('bankid', e.target.value)}>
                    <option value="">เลือกธนาคาร</option>
                    {regBanks.map((b) => (<option key={b.bank_id} value={b.bank_id}>{b.fullname_th || b.acro}</option>))}
                  </select>
                </div>
                <div className="aff-field"><label>เลขที่บัญชี</label><input className="aff-input" autoComplete="off" value={reg.accountno} onChange={(e) => setR('accountno', e.target.value)} /></div>
              </div>
              <div className="aff-field"><label>ชื่อบัญชี</label><input className="aff-input" autoComplete="off" value={reg.accountname} onChange={(e) => setR('accountname', e.target.value)} /></div>
              <div className="aff-row2">
                <div className="aff-field"><label>กระเป๋า USDT (ทางเลือก)</label>
                  <select className="aff-input" value={reg.wnet} onChange={(e) => setR('wnet', e.target.value)}>
                    <option value="TRC20">USDT — TRON (TRC20)</option>
                    <option value="ERC20">USDT — Ethereum (ERC20)</option>
                  </select>
                </div>
                <div className="aff-field"><label>ที่อยู่กระเป๋า (Wallet Address)</label><input className="aff-input" autoComplete="off" value={reg.waddr} onChange={(e) => setR('waddr', e.target.value)} /></div>
              </div>
              <div className="aff-row2">
                <div className="aff-field"><label>ช่วงเวลาที่สะดวกให้ติดต่อ</label>
                  <select className="aff-input" value={reg.time} onChange={(e) => setR('time', e.target.value)}>
                    <option value="">เลือกช่วงเวลา</option><option>09:00-12:00</option><option>12:00-15:00</option><option>15:00-18:00</option><option>18:00-21:00</option><option>21:00-00:00</option>
                  </select>
                </div>
                <div className="aff-field"><label>คำถามความปลอดภัย *</label>
                  <select className="aff-input" value={reg.secq} onChange={(e) => setR('secq', e.target.value)}>
                    <option value="">เลือกคำถาม</option><option>ชื่อสัตว์เลี้ยงตัวแรกของคุณ</option><option>โรงเรียนประถมของคุณ</option><option>เมืองที่คุณเกิด</option><option>ชื่อเล่นวัยเด็กของคุณ</option>
                  </select>
                </div>
              </div>
              <div className="aff-row2">
                <div className="aff-field"><label>คำตอบความปลอดภัย *</label><input className="aff-input" autoComplete="off" value={reg.seca} onChange={(e) => setR('seca', e.target.value)} /></div>
                <div className="aff-field"><label>รหัสอ้างอิงของพันธมิตร</label><input className="aff-input" autoComplete="off" value={reg.ref} onChange={(e) => setR('ref', e.target.value)} /></div>
              </div>
              <div style={{ display: 'flex', gap: 9, alignItems: 'flex-start', margin: '6px 0 16px', color: 'var(--muted)', fontSize: 13 }}>
                <input type="checkbox" checked={reg.agree} onChange={(e) => setR('agree', e.target.checked)} />
                <span>ยอมรับ <b style={{ color: 'var(--gold)' }}>ข้อกำหนดและเงื่อนไข</b> การเป็นพันธมิตร</span>
              </div>
              <button className="aff-btn aff-gold" style={{ width: '100%', fontSize: 16, opacity: regLoading ? 0.6 : 1 }} disabled={regLoading} onClick={doRegister}>{regLoading ? 'กำลังสมัคร...' : 'ยืนยันการสมัคร'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
